import { useQuery } from "react-query";
import { ThreeDots } from "react-loader-spinner";
import { getUserRole } from "../../utils/auth.js";

// components
import Card from "../../components/cards/Card.jsx";
//services
import { getGraphics } from "../../services/Dashboard/getGraphics.js";
//utils
import { formatCurrency } from "../../utils/formatCurrency.js";
import { useAppContext } from "../../context/AppContext.jsx";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

const InfoCards = () => {
  const navigate = useNavigate();
  const { permissions } = useAppContext();
  const { data: valueToPay } = useQuery(
    "valueToPay",
    () => getGraphics("bills_to_pay"),
    {
      enabled: !!permissions?.includes("5"),
    }
  );

  const { data: valueToReceive } = useQuery(
    "valueToReceive",
    () => getGraphics("accounts_to_receive"),
    {
      enabled: !!permissions?.includes("5"),
    }
  );

  const { data: nonPaymentTotal } = useQuery(
    "nonPaymentTotal",
    () => getGraphics("non_payment_total"),
    {
      enabled: !!permissions?.includes("5"),
    }
  );

  const hasPermission170 = permissions?.includes("170");
  const hasPermission112 = permissions?.includes("112");
  const hasPermission129 = permissions?.includes("129");
  const userRole = getUserRole();

  return (
    <>
      <Card
        title={"Contas a Pagar Geral"}
        value={
          valueToPay ? (
            formatCurrency(valueToPay.bills_to_pay)
          ) : (
            <ThreeDots
              visible={true}
              height="50"
              width="80"
              color="#fff"
              radius="9"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          )
        }
        size="col-xl-4 col-md-12"
        desc={
          hasPermission170
            ? "Total do Mês (em aberto)"
            : userRole === "Admin"
              ? "Clique para contratar o módulo"
              : "Sem permissão para visualizar"
        }
        class={"widget widget-stats bg-indigo pb-0 mb-2"}
        icon={<i className="fa fa-money-bill-1 fa-fw"></i>}
        onClick={
          hasPermission170
            ? () => navigate("/financial/accountToPay")
            : userRole === "Admin"
              ? () => navigate("/modules?id=5")
              : undefined
        }
      />
      <Card
        title="Contas a Receber Geral"
        value={
          valueToReceive && formatCurrency(valueToReceive.accounts_to_receive)
        }
        size="col-xl-4 col-md-12"
        desc={
          hasPermission112
            ? "Total do Mês (em aberto)"
            : "Sem permissão para visualizar"
        }
        class="widget widget-stats bg-blue pb-0 mb-2"
        icon={<i className="fa fa-dollar-sign fa-fw"></i>}
        onClick={
          hasPermission112 ? () => navigate("/financial/accountReceivable") : undefined
        }
      />
      <Card
        title="Inadimplência Total"
        value={nonPaymentTotal && formatCurrency(nonPaymentTotal.non_payment)}
        size="col-xl-4 col-md-12"
        desc={
          hasPermission129
            ? "Total Inadimplência (Sem Multa, Juros)"
            : "Sem permissão para visualizar"
        }
        class={"widget widget-stats bg-black bg-opacity-75 pb-0 mb-2"}
        icon={<i className="fa fa-gavel fa-fw"></i>}
        onClick={
          hasPermission129 ? () => navigate("/reports/debtor") : undefined
        }
      />
    </>
  );
};

export default InfoCards;
